// extracted by mini-css-extract-plugin
export default {"darkTheme":"style_darkTheme__8BHXs","lightTheme":"style_lightTheme__snf+F","st-2":"style_st-2__4vaIA","st-has-labels":"style_st-has-labels__TX0E0","st-btn":"style_st-btn__8LKQ4"};